import { BiCheck } from "react-icons/bi";
import { Button, Card, Col, Row, theme } from "antd";
import React from "react";
import { AiOutlineCalendar } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";

export const PrestationAnswerYes = props => {
  const {
    token: { colorPrimary },
  } = theme.useToken();

  const navigate = useNavigate();

  return (
    <div className={"center-full"}>
      <Card className={"confirmYes"}>
        <div className={"checkBig"}>
          <BiCheck color={colorPrimary} size={60} />
        </div>
        <h2>{t("prestationAnswerYes.title")}</h2>

        <p>{t("prestationAnswerYes.message")}</p>
        <Row style={{ width: "100%" }}>
          <Col md={12} xs={24}>
            <Button
              size={"large"}
              className={"confirmButton"}
              type={"primary"}
              icon={<AiOutlineCalendar size={20} />}
            >
              {t("prestationAnswerYes.addToMyCalendar")}
            </Button>
          </Col>
          <Col md={12} xs={24}>
            <Button
              size={"large"}
              className={"confirmButton"}
              onClick={() => {
                navigate("/", { replace: true });
              }}
            >
              {t("routes.back")}
            </Button>
          </Col>
        </Row>
      </Card>
    </div>
  );
};
